// extracted by mini-css-extract-plugin
export default {"blankButton":"styles_blankButton__DYLIr","removeButton":"styles_removeButton__4tcdB","clicked":"styles_clicked__Suu1N"};